// Datos de la empresa — Manfredi Weber
export const COMPANY = {
  name: "Manfredi Weber",
  legalTagline: "Industria Argentina",
  shortDesc:
    "Fabricantes de cabezales de bronce trefilado para griferías. 100% argentino.",
  // Teléfono / WhatsApp principal (Soledad Weber)
  phoneDisplay: "+54 9 11 2191-4052",
  // Formato E.164 sin símbolos para wa.me / tel:
  phoneRaw: "5491121914052",
  email: "mwfabrica@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=61587593558373",
  instagram: "https://www.instagram.com/mw_cabezales",
  contacts: [
    {
      name: "Marcelo Manfredi",
      role: "Socio Gerente Fundador",
      phoneDisplay: "+54 9 11 3227-6956",
      phoneRaw: "5491132276956",
    },
    {
      name: "Soledad Weber",
      role: "Socia Cofundadora",
      phoneDisplay: "+54 9 11 2191-4052",
      phoneRaw: "5491121914052",
    },
  ],
  location: "Villa de Mayo, Provincia de Buenos Aires",
  addressLine: "Villa de Mayo, Provincia de Buenos Aires",
  country: "Argentina",
  mapEmbed:
    "https://www.google.com/maps?q=Villa%20de%20Mayo,%20Buenos%20Aires,%20Argentina&z=13&output=embed",
  mapLink:
    "https://www.google.com/maps/place/Villa+de+Mayo,+Provincia+de+Buenos+Aires,+Argentina",
  hours: [
    { day: "Lunes a Viernes", time: "8:00 a 16:00 hs" },
    { day: "Sábados", time: "9:00 a 13:00 hs" },
    { day: "Domingos", time: "Cerrado" },
  ],
};

export const CATEGORIES = ["Cabezales", "Repuestos", "Accesorios", "Otros"];
